const INGREDIENT_SUPPORTING_KEYWORDS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: {
    synonyms: [],
    varieties: [],
    uncategorized: [],
    discarded: [],
  },
  checkedKeywordKeys: {
    synonyms: [],
    varieties: [],
    uncategorized: [],
    discarded: [],
  },
}

export default INGREDIENT_SUPPORTING_KEYWORDS_INITIAL_STATE
